import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  '@keyframes bgLoader': {
    '0%': {
      backgroundPosition: '0% 50%'
    },
    '50%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  },
  '@keyframes logoLoader': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '90%': {
      transform: 'rotate(720deg)'
    },
    '100%': {
      transform: 'rotate(720deg)'
    }
  },
  loaderWrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 99999,
    background: 'linear-gradient(90deg, #F4F4F4 0%, #F4F4F41A 20%, #F4F4F4 40%, #F4F4F41A 60%, #F4F4F4 80%, #F4F4F41A 100%)',
    backgroundSize: '300% 300%',
    animation: '$bgLoader 3s ease-in-out infinite'
  },
  logoLoader: {
    width: 40,
    height: 40,
    animation: '$logoLoader 2s ease-in-out infinite'
  }
}))

export default useStyles
